import { GIFEncoder, quantize, applyPalette } from 'gifenc';
import { Output, BufferTarget, Mp4OutputFormat, CanvasSource, canEncodeVideo } from 'mediabunny';

const videoConfig={codec:'avc',bitrate:1_200_000};
export async function supportsAnimationMp4(width,height){
  try{return await canEncodeVideo('avc',{width,height,bitrate:videoConfig.bitrate});}
  catch{return false;}
}

export async function encodeAnimation({format,canvas,duration,draw,signal,onProgress}){
  const fps=format==='gif'?20:30;
  const frames=Math.max(1,Math.ceil(duration*fps));
  const gif=format==='gif'?GIFEncoder():null;
  const output=gif?null:new Output({format:new Mp4OutputFormat({fastStart:'in-memory'}),target:new BufferTarget()});
  const source=output?new CanvasSource(canvas,videoConfig):null;
  const ctx=canvas.getContext('2d',{willReadFrequently:!!gif});
  try{
    if(output){output.addVideoTrack(source,{frameRate:fps});await output.start();}
    for(let i=0;i<frames;i++){
      signal.throwIfAborted();
      draw(Math.min(i/fps,duration));
      if(gif){
        const {data}=ctx.getImageData(0,0,canvas.width,canvas.height);
        const palette=quantize(data,128);
        gif.writeFrame(applyPalette(data,palette),canvas.width,canvas.height,{palette,delay:1000/fps,repeat:0});
      }else await source.add(i/fps,1/fps);
      if(i%4===0){onProgress((i+1)/frames);await new Promise(resolve=>setTimeout(resolve,0));}
    }
    signal.throwIfAborted();
    if(gif){gif.finish();return new Blob([gif.bytes()],{type:'image/gif'});}
    source.close();await output.finalize();
    signal.throwIfAborted();
    return new Blob([output.target.buffer],{type:'video/mp4'});
  }catch(error){
    if(output)await output.cancel().catch(()=>{});
    throw error;
  }
}
